import {   
    geocode
} from "react-geocode";
import { GOOGLE_MAP_API } from "../../../config";

export default class Geocode {

    geoCodeMarkerPosition = async (lat, lng) => {
        let GeolocationData = {};
        await geocode("latlng", `${lat},${lng}`, {
            key: GOOGLE_MAP_API
        }).then(
            response => {
                const addressArray = response.results[0].address_components;

                GeolocationData = {
                    fullAddress: this.getAddress(response.results[0].address_components),
                    address: (this.getAddress(addressArray)) ? this.getAddress(addressArray) : '',
                    area: (this.getArea(addressArray)) ? this.getArea(addressArray) : '',
                    city: (this.getCity(addressArray)) ? this.getCity(addressArray) : '',
                    state: (this.getState(addressArray)) ? this.getState(addressArray) : '',
                    postalCode: (this.getPostcode(addressArray)) ? this.getPostcode(addressArray) : '',
                    streetNumber: (this.getStreetNumber(addressArray)) ? this.getStreetNumber(addressArray) : '',
                };
            },
            error => {
                console.error(error);
            }
        );
        return GeolocationData;
    }

    /**
  * Get the city and set the city input value to the one selected
  *
  * @param addressArray
  * @return {string}
  */
    getCity = (addressArray) => {
        let city = '';
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0] && 'political' === addressArray[i].types[0] && 'sublocality' === addressArray[i].types[1]) {
                city = addressArray[i].long_name;
                return city;
            }
            else if (addressArray[i].types[0] && 'postal_town' === addressArray[i].types[0]) {
                city = addressArray[i].long_name;
                return city;
            }
        }
    };
    /**
 * Get the address and set the address input value to the one selected
 *
 * @param addressArray
 * @return {string}
 */
    getAddress = (addressArray) => {
        let address = '';
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0] && 'route' === addressArray[i].types[0]) {
                address = addressArray[i].long_name;
                return address;
            }
        }
    };
    /**
 * Get the address and set the address input value to the one selected
 *
 * @param addressArray
 * @return {string}
 */
    getPostcode = (addressArray) => {
        let postcode = '';
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0] && 'postal_code' === addressArray[i].types[0]) {
                postcode = addressArray[i].long_name;
                return postcode;
            }
        }
    };
    getStreetNumber = (addressArray) => {
        let streetNumber = '';
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0] && 'street_number' === addressArray[i].types[0]) {
                streetNumber = addressArray[i].long_name;
                return streetNumber;
            }
        }
    };
    /**
      * Get the area and set the area input value to the one selected
      *
      * @param addressArray
      * @return {string}
      */
    getArea = (addressArray) => {
        let area = '';
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0]) {
                for (let j = 0; j < addressArray[i].types.length; j++) {
                    if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
                        area = addressArray[i].long_name;
                        return area;
                    }
                }
            }
        }
    };
    /**
      * Get the address and set the address input value to the one selected
      *
      * @param addressArray
      * @return {string}
      */
    getState = (addressArray) => {
        let state = '';
        for (let i = 0; i < addressArray.length; i++) {
            for (let i = 0; i < addressArray.length; i++) {
                if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
                    state = addressArray[i].long_name;
                    return state;
                }
            }
        }
    };
}